import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import AppHeader from '../components/AppHeader';
import PasswordInput from '../components/PasswordInput';
import { changePassword } from '../api/driversApi';
import { useToast } from '../context/ToastContext';

function ChangePassword() {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const { register, handleSubmit, watch, formState: { errors } } = useForm();
  const [submitting, setSubmitting] = useState(false);

  const newPasswordValue = watch('new_password');

  const onSubmit = async (data) => {
    setSubmitting(true);
    try {
      const result = await changePassword(data.current_password, data.new_password);
      if (result.success) {
        showToast('success', 'Password changed successfully.');
        navigate('/profile');
      } else {
        showToast('error', result.message || 'Failed to change password.');
      }
    } catch (err) {
      showToast('error', 'Could not connect to server.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f9fafb' }}>
      <AppHeader title="Change Password" showBack={true} fallbackRoute="/profile" />

      <div style={{ padding: 16 }}>
        <form onSubmit={handleSubmit(onSubmit)} style={styles.card}>
          <label style={styles.label}>Current Password</label>
          <PasswordInput
            {...register('current_password', { required: true })}
            style={styles.input}
          />
          {errors.current_password && <p style={styles.errorText}>Required</p>}

          <label style={styles.label}>New Password</label>
          <PasswordInput
            {...register('new_password', {
              required: true,
              minLength: { value: 6, message: 'Must be at least 6 characters' },
            })}
            style={styles.input}
          />
          {errors.new_password && (
            <p style={styles.errorText}>{errors.new_password.message || 'Required'}</p>
          )}

          <label style={styles.label}>Confirm New Password</label>
          <PasswordInput
            {...register('confirm_password', {
              required: true,
              validate: (value) => value === newPasswordValue || 'Passwords do not match',
            })}
            style={styles.input}
          />
          {errors.confirm_password && (
            <p style={styles.errorText}>{errors.confirm_password.message || 'Required'}</p>
          )}

          <button type="submit" disabled={submitting} style={styles.submitButton}>
            {submitting ? '...' : 'Change Password'}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  card: {
    backgroundColor: 'white',
    borderRadius: 12,
    padding: 20,
    boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
  },
  label: {
    display: 'block',
    fontSize: 13,
    fontWeight: 600,
    color: '#374151',
    marginBottom: 6,
    marginTop: 16,
  },
  input: {
    width: '100%',
    padding: '12px 14px',
    borderRadius: 10,
    border: '1px solid #e5e7eb',
    fontSize: 14,
    color: '#111827',
    outline: 'none',
    boxSizing: 'border-box',
  },
  errorText: {
    color: '#dc2626',
    fontSize: 12,
    marginTop: 4,
  },
  submitButton: {
    width: '100%',
    backgroundColor: '#2563eb',
    color: 'white',
    fontWeight: 700,
    fontSize: 15,
    padding: '14px 0',
    borderRadius: 10,
    border: 'none',
    cursor: 'pointer',
    marginTop: 24,
  },
};

export default ChangePassword;
